<script setup lang="ts">
import { computed } from 'vue'

import BcLink from '~/ui/Link/BcLink.vue'

interface IProps {
  address: string
  type?: string,
  name?: string
  hideEoaIcon?: boolean
  isDetail?: boolean
  tooltip?: string
  lineBreak?: boolean
  centerEllipsis?: boolean
}

const props = withDefaults(defineProps<IProps>(), {
  isDetail: false,
  name: '',
  type: '',
  tooltip: undefined,
  centerEllipsis: false,
})

const getIconByType = (type: string) => {
  if (type === 'EOA') return 'wallet'
  else if (type === 'CA') return 'file-contract'
}

const icon = computed(() => {
  if (props.hideEoaIcon && props.type === 'EOA') return
  return getIconByType(props.type)
})

const iconTooltip = computed(() => {
  if (props.type === 'EOA') return 'External owned account'
  else if (props.type === 'CA') return 'Contract address'
  return undefined
})
</script>

<template>
  <BcLink
    :content="name || address"
    :to="routes.getAccountDetailPageWithTab(address, accountDetailPageType.transactions)"
    :tooltip="tooltip"
    :line-break="lineBreak"
    :center-ellipsis="centerEllipsis"
  >
    <template
      v-if="icon"
      #prefix
    >
      <FontAwesomeIcon
        v-tooltip="iconTooltip"
        :class="['group-hover:text-primary', isDetail ? 'text-primary' : 'text-primary/40']"
        :icon="icon"
      />
    </template>
  </BcLink>
</template>

<style scoped lang="scss">
</style>